import { distinctUntilChanged } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SyncService } from './sync.service';
import { Subject } from 'rxjs';
import { ProcessService } from 'src/app/modules/instance/services/process.service';
import { BaseAPIService } from 'src/app/shared/services/base-api.service';
import { SynchronizationEvent } from '../enums/synchronization-event';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import ITask = ZoningAPI.ITask;
import IInstance = ZoningAPI.IInstance;
import { ISynchronizationMessage } from '../interfaces/syncronization-message.interface';
import IProcessesStatisticDTO = ZoningAPI.IProcessesStatisticDTO;
import { InstanceService } from '../../instance/services';
import { ProcessesStatisticMapper } from 'src/app/shared/mappers/processes-statistic.mapper';

@Injectable()
export class SynchronizationEventService extends BaseAPIService {
    updatedProcessesSubject = new Subject<ITask[]>();
    deletedProcessesSubject = new Subject<ITask[]>();

    private changesSubject = new Subject();
    changes = this.changesSubject.asObservable().pipe(distinctUntilChanged());

    processesStatisticMapper: ProcessesStatisticMapper;

    constructor(
        private syncService: SyncService,
        private processService: ProcessService,
        private instanceService: InstanceService,
        protected readonly snackBar: MatSnackBar
    ) {
        super();
        this.processesStatisticMapper = new ProcessesStatisticMapper();
        this.initHandlers();
    }

    initHandlers() {
        this.syncService.initEventHandler('connected', data => {
            console.log('connected');
            console.log(data);
        });

        this.syncService.initEventHandler(
            SynchronizationEvent.PROCESSES_STATISTIC,
            (data: ISynchronizationMessage<IProcessesStatisticDTO>) => {
                this.processService.setProcessesStatistic(this.processesStatisticMapper.fromDTO(this.getData(data)));
            }
        );

        this.syncService.initEventHandler(
            SynchronizationEvent.UPDATED_PROCESSES,
            (data: ISynchronizationMessage<ITask[]>) => {
                const tasksData: ITask[] = this.getData(data);
                this.processService.updateProcesses(tasksData);
                this.updatedProcessesSubject.next(tasksData);
            }
        );

        this.syncService.initEventHandler(
            SynchronizationEvent.CAN_NOT_START_PROCESSES,
            (data: ISynchronizationMessage<ITask>) => {
                const processData = this.getData<ITask>(data);
                this.processService.updateProcesses([processData]);
                this.snackBar.open(
                    `Can not start process ${processData.id}. Maximum threads capacity is reached.`,
                    'OK',
                    {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 4000
                    }
                );
            }
        );

        this.syncService.initEventHandler(
            SynchronizationEvent.ADD_PROCESSES_TO_START_QUEUE,
            (data: ISynchronizationMessage<ITask>) => {
                const processData = this.getData<ITask>(data);
                this.processService.updateProcesses([processData]);
                this.snackBar.open(
                    `Can not start process ${processData.id} immediately. To prevent system overload the process will be started later.`,
                    'OK',
                    {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 4000
                    }
                );
            }
        );

        this.syncService.initEventHandler(
            SynchronizationEvent.PROCESSES_DELETED,
            (data: ISynchronizationMessage<ITask[]>) => {
                const tasksData: ITask[] = this.getData(data);
                this.processService.removeJobsAndTasks(tasksData);
                this.deletedProcessesSubject.next(tasksData);
            }
        );

        this.syncService.initEventHandler(
            SynchronizationEvent.PROCESS_CREATED,
            (data: ISynchronizationMessage<ITask>) => {
                this.processService.processNewProcess(this.getData(data));
            }
        );

        this.syncService.initEventHandler(
            SynchronizationEvent.PROCESSES_ARCHIVED,
            (data: ISynchronizationMessage<ITask[]>) => {
                /**
                 * Currently we archive those Tasks which were finished
                 * instead of deleting them. But archived Task should be hided
                 * so it can be threated like it was deleted.
                 */
                this.processService.removeJobsAndTasks(this.getData(data));
            }
        );

        this.syncService.initEventHandler(
            SynchronizationEvent.INSTANCE_STATISTIC_CHANGED,
            (data: ISynchronizationMessage<IInstance>) => {
                this.instanceService.updateInstanceFromJSON(this.getData(data));
            }
        );
    }
}
